import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const KLARNA: PaymentMethod = {
    id: PAYMENT_METHOD_ID.Klarna,
    name: 'klarna',
    displayName: 'Klarna'
};
